import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { ArrowRight, PartyPopper, ShieldOff } from 'lucide-react';

import InvitationShell from './InvitationShell';

/**
 * Where a newly accepted user lands: a pointer to the first studio they can open, or an
 * explanation to contact their administrator when they can open none.
 *
 * @param {object} props
 * @param {string} props.workspaceName
 * @param {string} [props.studioName] First accessible studio; omit when there is none.
 * @param {() => void} [props.onOpen]
 */
const FirstLoginLanding = ({ workspaceName, studioName, onOpen }) => {
  const { t } = useTranslation('people-access');

  if (!studioName) {
    return (
      <InvitationShell>
        <ShieldOff size={32} className="text-content-muted" aria-hidden />
        <div>
          <h1 className="m-0 text-xl font-semibold text-content">
            {t('invitation.firstLogin.noAccessTitle')}
          </h1>
          <p className="m-0 mt-1 text-sm text-content-muted">
            {t('invitation.firstLogin.noAccessSubtitle')}
          </p>
        </div>
      </InvitationShell>
    );
  }

  return (
    <InvitationShell>
      <PartyPopper size={32} className="text-accent" aria-hidden />
      <div>
        <h1 className="m-0 text-xl font-semibold text-content">
          {t('invitation.firstLogin.title', { workspace: workspaceName })}
        </h1>
        <p className="m-0 mt-1 text-sm text-content-muted">{t('invitation.firstLogin.subtitle')}</p>
      </div>
      <Button rightIcon={ArrowRight} onClick={onOpen}>
        {t('invitation.firstLogin.open', { studio: studioName })}
      </Button>
    </InvitationShell>
  );
};

export default memo(FirstLoginLanding);
